import React, { useState, useCallback, useRef, useMemo, useEffect } from 'react';
import axios from '../axios';
import moment from 'moment';

const PlaceReservation = ({ place, eventId, eventDateDefault, eventEndDefault, initialData = {}, onBack, onFinish }) => {
  const isDesktop = window.innerWidth >= 768;
  const [startAt, setStartAt] = useState(() => {
    if (eventDateDefault) {
      const datetime = isDesktop ? 'YYYY/MM/DD HH:mm' : 'YYYY-MM-DDTHH:mm';
      return moment(eventDateDefault).format(datetime);
    }
    return '';
  });
  const [endAt, setEndAt] = useState(() => {
    if (eventEndDefault) {
      const datetime = isDesktop ? 'YYYY/MM/DD HH:mm' : 'YYYY-MM-DDTHH:mm';
      return moment(eventEndDefault).format(datetime);
    }
    return '';
  });
  const isTouchedEnd = useRef(false);
  const [numPeople, setNumPeople] = useState(initialData.num_people?.toString() || '');
  const [requestTxt, setRequestTxt] = useState(initialData.request_detail || '');
  const [name, setName] = useState(initialData.reserver_name || '');
  const [tel, setTel] = useState(initialData.reserver_tel || '');
  const [errors, setErrors] = useState({});
  const datetimeFormType = isDesktop ? 'text' : 'datetime-local';
  const datetimeFormat = isDesktop ? 'YYYY/MM/DD HH:mm' : 'YYYY-MM-DDTHH:mm';
  const minMoment = moment().add(5, 'days');
  const maxMoment = moment().add(3, 'months');
  const minDatePicker = minMoment.format('YYYY/MM/DD');
  const maxDatePicker = maxMoment.format('YYYY/MM/DD');
  const minDateTimeLocal = minMoment.format('YYYY-MM-DDTHH:mm');
  const maxDateTimeLocal = maxMoment.format('YYYY-MM-DDTHH:mm');
  const peopleOptions = useMemo(() => Array.from({ length: 100 }, (_, i) => i + 1), []);

  React.useEffect(() => {
    if (!isDesktop) return;
    $('.datetimepicker').each(function () {
      $(this).datetimepicker({
        format : 'Y/m/d H:i',
        lang : 'ja',
        timepicker: true,
        step : 5,
        scrollInput:true,
        minDate : minDatePicker,
        maxDate : maxDatePicker,
      });
    });
  }, [minDatePicker, maxDatePicker, isDesktop]);

  useEffect(() => {
    if (!startAt || isTouchedEnd.current) return;
    const startMoment = moment(startAt, ['YYYY/MM/DD HH:mm', 'YYYY-MM-DDTHH:mm'], true);
    if (!startMoment.isValid()) return;
    const autoEndMoment = startMoment.clone().add(2, 'hours');
    const formattedEnd = autoEndMoment.format(datetimeFormat);
    setEndAt(formattedEnd);
  }, [startAt, isDesktop, datetimeFormat]);

  const validate = useCallback(() => {
    const validationErrors = {};
    if (!startAt) validationErrors.startAt = '必須';
    if (!endAt) validationErrors.endAt = '必須';
    if (!numPeople) validationErrors.numPeople = '必須';
    if (!name) validationErrors.name = '必須';
    if (!tel) validationErrors.tel = '必須';
    if (startAt && endAt && moment(startAt) >= moment(endAt)) {
      validationErrors.endAt = '開始より後の時刻を指定してください';
    }
    if (startAt && moment(startAt) < minMoment) {
      validationErrors.startAt = '予約は5日後以降を選択してください';
    }
    if (tel && !/^\d{10,11}$/.test(tel)) {
      validationErrors.tel = 'ハイフンを除いた有効な電話番号を入力してください';
    }
    setErrors(validationErrors);
    return Object.keys(validationErrors).length === 0;
  }, [startAt, endAt, numPeople, name, tel, minMoment]);


  const handleSubmit = useCallback(() => {
    if (!validate()) return;
    const normalize = (value) => {
      if (!value) return null;
      const momentObject = moment(value, ['YYYY/MM/DD HH:mm', 'YYYY-MM-DDTHH:mm'], true);
      return momentObject.isValid() ? momentObject.format('YYYY-MM-DD HH:mm') : null;
    };
    axios.post(`/api/places/${place.id}/reserve`, {
      reservation: {
        event_id: eventId,
        start_at: normalize(startAt),
        end_at: normalize(endAt),
        num_people: Number(numPeople),
        request_detail: requestTxt,
        reserver_name: name,
        reserver_tel: tel,
      },
    }).then((res) => {
      const reservationId = res.data.id;
      alert('予約を受け付けました。イベント公開後に予約が実行されます。');
      if (onFinish) {
        onFinish({
          id: reservationId,
          place_id: place.id,
          place_name: place.name,
          start_at: normalize(startAt),
          end_at: normalize(endAt),
          num_people: Number(numPeople),
          request_detail: requestTxt,
          reserver_name: name,
          reserver_tel: tel,
        });
      }
    }).catch((error) => {
      alert(error.response?.data?.error || '予約に失敗しました。入力内容をご確認ください。');
    });
  }, [validate, place.id, eventId, startAt, endAt, numPeople, requestTxt, name, tel, onFinish]);

  return (
    <main className="bg-white min-vh-100">
      <div className="container col-md-8 col-lg-6 py-3">
        <button className="btn text-gray px-0 mb-2" onClick={onBack}>← 戻る</button>
        <h1 className="h5 font-weight-bold mb-4">{place.name}</h1>

        <label className="row justify-content-between p-3_5 border-bottom">
          <div className="d-flex flex-column">
            <span>開始時刻 <span className="text-danger">*必須</span></span>
            <span className="mb-1 text-fz-small text-gray">5日後以降を選択してください。</span>
          </div>
          <input
            type={datetimeFormType}
            className="datetimepicker form-style-reset p-0 textarea--eventreport text-right bg-gray"
            value={startAt ? moment(startAt).format(datetimeFormat) : ''}
            onChange={event => setStartAt(event.target.value)}
            onBlur={event => setStartAt(event.target.value)}
            placeholder="必須"
            autoComplete="off"
            {...(!isDesktop && { min: minDateTimeLocal, max: maxDateTimeLocal })}
          />
        </label>
        {errors.startAt && <p className="text-danger mb-3 text-fz-small">{errors.startAt}</p>}

        <label className="row justify-content-between p-3_5">
          <span>終了時刻 <span className="text-danger">*必須</span></span>
          <input
            type={datetimeFormType}
            className="datetimepicker form-style-reset p-0 textarea--eventreport text-right bg-gray"
            value={endAt ? moment(endAt).format(datetimeFormat) : ''}
            onChange={event =>{ isTouchedEnd.current = true; setEndAt(event.target.value);}}
            onBlur={event =>{ isTouchedEnd.current = true; setEndAt(event.target.value);}}
            placeholder="必須"
            autoComplete="off"
            {...(!isDesktop && { min: minDateTimeLocal, max: maxDateTimeLocal })}
          />
        </label>
        {errors.endAt && <p className="text-danger mb-3 text-fz-small">{errors.endAt}</p>}

        <label className="d-block mt-4 mb-2">利用人数 <span className="text-danger">*</span></label>
        <select className="form-control mb-3" value={numPeople} onChange={event => setNumPeople(event.target.value)}>
          <option value="">選択してください</option>
          {peopleOptions.map((personCount) => (
            <option key={personCount} value={personCount}>
              {personCount} 人
            </option>
          ))}
        </select>
        {errors.numPeople && <p className="text-danger text-fz-small mb-2">{errors.numPeople}</p>}

        <label className="d-block mb-0">要望（ルームの希望など）</label>
        <p className="mb-0 text-fz-small text-gray">ルームの種類や店舗詳細は
          <a href={place.description} target="_blank" rel="noopener noreferrer" className="ml-1 text-primary">こちら</a>からご確認ください。
        </p>
        <p className="mb-1 text-fz-small text-gray">※予約状況によってはご希望に添えない可能性がございます。ご了承下さい。</p>
        <textarea rows="3" className="w-100 form-control mb-3" value={requestTxt} onChange={event=>setRequestTxt(event.target.value)} />

        <label className="d-block mb-2">予約代表者氏名（カタカナ）<span className="text-danger">*必須</span></label>
        <input type="text" className="w-100 form-control mb-3" value={name} onChange={event=>setName(event.target.value)} />
        {errors.name && <p className="text-danger mb-3 text-fz-small">{errors.name}</p>}

        <label className="d-block mb-0">予約代表者電話番号 <span className="text-danger">*必須</span></label>
        <p className="mb-1 text-fz-small text-gray">※ ハイフンは省略し、数字のみで入力してください</p>
        <input type="tel" className="w-100 form-control mb-4" value={tel} onChange={event=>setTel(event.target.value)} placeholder="例）09012345678" />
        {errors.tel && <p className="text-danger mb-3 text-fz-small">{errors.tel}</p>}
        <div className="alert alert-warning text-fz-14px mb-3">
          <p className="mb-1">・会場の予約手数料は<strong>かかりません</strong>。</p>
          <p className="mb-1">・イベント公開後に、会場が予約されます。</p>
          <p className="mb-0">・ご希望の日時で予約できなかった場合は、<strong>アプリ内メッセージ</strong>にてご連絡いたします。</p>
        </div>
        <div className="d-flex">
          <button type="button" className="w-50 border-0 py-3 text-fz-13px text-dark mr-1" style={{ backgroundColor: '#E0E0E0' }} onClick={onBack}>
            戻る
          </button>
          <button type="button" onClick={handleSubmit} className="w-50 border-0 py-3 text-white ml-1 text-fz-13px" style={{ backgroundColor: '#FF4D5B' }}>
            この会場を予約
          </button>
        </div>
      </div>
    </main>
  );
};

export default PlaceReservation;
